module.exports = __webpack_public_path__ + "img/conídios 1.2d70f1fa.webp";